module.exports = __webpack_public_path__ + "img/cosmetic_top.d3a802e9.svg";